import React, { useEffect, useState } from "react";
import {
  Button,
  Box,
  Typography,
  IconButton,
  Pagination,
  PaginationItem,
  Stack,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  styled,
  OutlinedInput,
  Grid,
  Divider,
} from "@mui/material";
// import Grid from "@mui/material/Grid";
import FilterSidebar from "../components/FilterSidebar";
import JobCard from "../components/JobCards";
import BreadCrumb from "../components/BreadCrumb";
import {
  ArrowDropDown,
  ExpandLess,
  ExpandMore,
  FilterList,
  GridView,
  SkipNextOutlined,
  SkipPreviousOutlined,
} from "@mui/icons-material";
import { GridIcon, ListIcon, SelectIcon } from "../assets/browse-job/Icons";
import ListCard from "../components/ListCard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import API from "../api";
import SkeletonCard from "../components/SkeletonCard";
import ApplyModal from "../components/ApplyModal";
import ChooseUs from "../components/why-choose-us/ChooseUs";
import FindJobSection from "../components/FindJobSection";
import NodataFoundCard from "../components/NodataFoundCard";

const BrowseJobs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams(); // Get the optional ID parameter
  const [specialities, setSpecialities] = useState([]);
  const [locations, setLocations] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [viewType, setViewType] = useState("grid");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const [appliedFilters, setAppliedFilters] = useState({
    specialties: [],
    pay_rate_min: null,
    pay_rate_max: null,
    locations: [],
    shifts: [],
  });
  const [pagination, setPagination] = useState({
    currentPage: 1,
    lastPage: 1,
    perPage: 50,
    total: 0,
  });
  const StyledSelect = styled(Select)({
    border: "none",
    outline: "none",
  });
  const handleChange = (event) => {
    setPagination((prev) => ({
      ...prev,
      perPage: parseInt(event.target.value, 10),
    }));
  };
  const handleViewClick = (job) => {
    localStorage.setItem("job-details", JSON.stringify(job));
    navigate(`/Shglocums/browse-jobs/job-details/${job?.id}`, {
      state: job,
    });
  };
  const applicants = [
    { photo: "https://randomuser.me/api/portraits/women/1.jpg" },
    { photo: "https://randomuser.me/api/portraits/men/2.jpg" },
    { photo: "https://randomuser.me/api/portraits/women/3.jpg" },
    { photo: "https://randomuser.me/api/portraits/men/4.jpg" },
  ];

  const breadcrumbItems = [
    { text: "Home", href: `/Shglocums/browse-jobs/` },
    { text: "Browse jobs", href: `/Shglocums/browse-jobs/` },
  ];
  const paginateChangeHandler = (e, page) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };
  const getJobsHandler = async (obj) => {
    const params = {
      paginate: pagination.perPage || 20,
      page: pagination.currentPage || 1,
    };
    setIsLoading(true);
    try {
      const queryString = new URLSearchParams(params).toString();
      const resp = await API.get(
        `/api/get-opened-jobs?${obj ? obj : queryString}`
      );
      if (resp?.data?.success) {
        setPagination({
          currentPage: resp?.data?.data?.current_page,
          lastPage: resp?.data?.data?.last_page,
          perPage: resp?.data?.data?.per_page,
          total: resp?.data?.data?.last_page,
        });
        setIsLoading(false);
        setData(resp?.data?.data?.data);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  // Function to fetch job details by ID
  const getJobById = async (jobId) => {
    try {
      const resp = await API.get(`/api/get-posted-job-detail/${jobId}`);
      if (resp?.data?.success) {
        const job = resp?.data?.data;
        if (job) {
          // Automatically open the apply modal for this job
          setOpen(jobId);
          // Update the URL to remove the ID parameter
          navigate("/Shglocums/browse-jobs", { replace: true });
        }
      }
    } catch (error) {
      console.log(error);
      // If the specific job API fails, fall back to the general jobs list
      try {
        const resp = await API.get(`/api/get-opened-jobs?paginate=100&page=1`);
        if (resp?.data?.success) {
          const job = resp?.data?.data?.data?.find((job) => job.id == jobId);
          if (job) {
            setOpen(jobId);
            navigate("/Shglocums/browse-jobs", { replace: true });
          }
        }
      } catch (fallbackError) {
        console.log("Fallback also failed:", fallbackError);
      }
    }
  };

  const isFilterApplied = () => {
    return (
      appliedFilters.specialties.length > 0 ||
      appliedFilters.pay_rate_min !== null ||
      appliedFilters.pay_rate_max !== null ||
      appliedFilters.locations.length > 0 ||
      appliedFilters.shifts.length > 0
    );
  };
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const parsedFilters = {
      specialties: searchParams.getAll("speciality").map(Number),
      pay_rate_min: searchParams.get("pay_rate_min")
        ? parseInt(searchParams.get("pay_rate_min"))
        : null,
      pay_rate_max: searchParams.get("pay_rate_max")
        ? parseInt(searchParams.get("pay_rate_max"))
        : null,
      locations: searchParams.getAll("location").map(Number),
      shifts: searchParams.getAll("shift"),
    };
    setAppliedFilters(parsedFilters);
  }, [location.search]);

  useEffect(() => {
    if (!isFilterApplied()) {
      getJobsHandler();
    }
    let view = sessionStorage.getItem("view");
    if (view) {
      setViewType(view);
    }
  }, [pagination.currentPage, pagination.perPage]);

  // Effect to handle automatic apply modal opening when ID is provided
  useEffect(() => {
    if (id) {
      getJobById(id);
    }
  }, [id]);
  // Function to apply filters and update URL
  const applyFilters = (newFilters) => {
    const updatedFilters = { ...appliedFilters, ...newFilters };
    setAppliedFilters(updatedFilters);
    const searchParams = new URLSearchParams();
    updatedFilters.specialties.forEach((speciality) =>
      searchParams.append("speciality", speciality)
    );
    if (updatedFilters.pay_rate_min !== null) {
      searchParams.append("pay_rate_min", updatedFilters.pay_rate_min);
    }
    if (updatedFilters.pay_rate_max !== null) {
      searchParams.append("pay_rate_max", updatedFilters.pay_rate_max);
    }
    updatedFilters.locations.forEach((location) =>
      searchParams.append("location", location)
    );
    updatedFilters.shifts.forEach((shift) =>
      searchParams.append("shift", shift)
    );
    searchParams.append("paginate", 100);
    searchParams.append("page", 1);
    const formData = new URLSearchParams();
    // updatedFilters.specialties.forEach((speciality) =>
    //   formData.append("speciality", speciality)
    // );
    formData.append("speciality", updatedFilters.specialties?.join(","));
    if (updatedFilters.pay_rate_min !== null) {
      formData.append("pay_rate_min", updatedFilters.pay_rate_min);
    }
    if (updatedFilters.pay_rate_max !== null) {
      formData.append("pay_rate_max", updatedFilters.pay_rate_max);
    }
    // updatedFilters.locations.forEach((location) =>
    //   formData.append("location", location)
    // );
    formData.append("location", updatedFilters.locations?.join(","));
    updatedFilters.shifts.forEach((shift) => formData.append("shift", shift));
    formData.append("paginate", 100);
    formData.append("page", 1);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });

    getJobsHandler(formData.toString());
  };
  useEffect(() => {
    clearFilters();
  }, []);
  // Function to clear all filters
  const clearFilters = () => {
    setAppliedFilters({
      specialties: [],
      pay_rate_min: null,
      pay_rate_max: null,
      locations: [],
      shifts: [],
    });

    // Clear URL parameters
    navigate(location.pathname, { replace: true });

    // TODO: Refetch original jobs list
    getJobsHandler();
  };
  const handleApplyClick = (id) => {
    setOpen(id);
  };
  const closeHandler = () => {
    setOpen(null);
  };
  //------------------------------------------------------ LOCATIONS & SPECIALITIES
  const getSpecialities = async () => {
    try {
      // const resp = await API.get("/api/get-specialities");
      const resp = await API.get("/api/get-specialities-with-posted-jobs");
      if (resp?.data?.success) {
        setSpecialities(resp?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const getLocations = async () => {
    try {
      // const resp = await API.get("/api/get-states/231");
      const resp = await API.get("/api/get-states-with-posted-jobs");

      if (resp?.data?.success) {
        setLocations(resp?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getSpecialities();
    getLocations();
  }, []);
  //------------------------------------------------------ LOCATIONS & SPECIALITIES
  const searchHandler = async (search) => {
    try {
      // const [appliedFilters, setAppliedFilters] = useState({
      //   specialties: [],
      //   pay_rate_min: null,
      //   pay_rate_max: null,
      //   locations: [],
      //   shifts: [],
      // });
      setAppliedFilters((prevState) => ({
        ...prevState,
        specialties: [search?.specialty],
        locations: [search?.location],
      }));
      const formData = new URLSearchParams();
      formData.append("speciality", search?.specialty);
      formData.append("location", search?.location);
      if (search?.city) {
        formData.append("city", search?.city);
      }
      formData.append(
        "paginate",
        search?.specialty || search?.location || search?.city ? 100 : pagination.perPage || 20
      );
      formData.append("page", 1);

      getJobsHandler(formData.toString());
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <Box>
      <FindJobSection
        searchHandler={searchHandler}
        locations={locations}
        specialities={specialities}
      />
      <Box
        // className={"wordpress_main_container"}
        sx={{
          mx: "auto",
          // pt: { xs: "28px", xl: "28px" },
          // px: { xs: "7% !important", xl: "150px  !important" },
          maxWidth: "1620px !important",
          px: "15px",
          // width: "100%",
          bgcolor: "#FBFBFB",
          mt: "30px",
          mb: "60px",
        }}
      >
        <ApplyModal
          open={open}
          closeHandler={closeHandler}
          getJobsHandler={getJobsHandler}
        />
        <BreadCrumb items={breadcrumbItems} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Box>
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: "25px", xl: "36px" },
                  fontWeight: 400,
                  lineHeight: { xs: "38px", xl: "49.36px" },
                  fontFamily: "DM Serif Text",
                  letterSpacing: "0.37px",
                }}
              >
                Browse jobs
              </Typography>
              {/* <Button
                className={"wordpress_button"}
                onClick={() => setIsFilterVisible(!isFilterVisible)}
                variant="outlined"
                sx={{
                  display: { xs: "none", md: "flex" },
                  color: "black !important",
                  p: {
                    xs: "1px  0.5rem !important",
                    xl: "5px 0.8rem !important",
                  },
                  borderRadius: "8px !important",
                  border: `1px solid${
                    isFilterVisible ? "#A5A5A5" : "#A5A5A5"
                  } !important`,
                  mt: "5px !important",
                  fontWeight: { xs: 500, xl: 400 },
                  fontSize: { xs: "0.7rem !important", xl: "1rem !important" },
                  lineHeight: "24px",
                  bgcolor: isFilterVisible
                    ? "#E4E4E4 !important"
                    : "none !important",
                  "&:hover": {
                    color: "black !important",
                    bgcolor: isFilterVisible
                      ? "#E4E4E4 !important"
                      : "none !important",
                  },
                }}
              >
                Filter for a perfect job
                {isFilterVisible ? <ExpandLess /> : <ExpandMore />}
              </Button> */}
              <Button
                className={"wordpress_button"}
                onClick={() => setIsOpen(!isOpen)}
                variant="outlined"
                sx={{
                  display: { md: "none" },
                  color: "text.primary",
                  p: {
                    xs: "1px  0.5rem !important",
                    xl: "5px 0.8rem !important",
                  },
                  borderRadius: "8px !important",
                  border: `1px solid${
                    isFilterVisible ? "#A5A5A5" : "#A5A5A5"
                  } !important`,
                  mt: "5px !important",
                  fontWeight: { xs: 500, xl: 400 },
                  fontSize: { xs: "0.7rem !important", xl: "1rem !important" },
                  lineHeight: "24px",
                  bgcolor: isFilterVisible ? "#E4E4E4" : "none",
                }}
              >
                <FilterList sx={{ fontSize: "1rem", mr: 0.5 }} /> Filter
              </Button>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "right",
            }}
          >
            <Box>
              <Box sx={{ display: "flex", justifyContent: "right", gap: 0.5 }}>
                <Button
                  onClick={() => {
                    setViewType("grid");
                    sessionStorage.setItem("view", "grid");
                  }}
                  variant="outlined"
                  sx={{
                    color: "#464E60",
                    backgroundColor:
                      viewType === "grid" ? "#E4E7EC" : "transparent",
                    borderColor: "#0000001A",
                    borderRadius: "5px",
                    fontWeight: 500,
                    fontSize: "0.75rem",
                    height: "37px",
                    display: "flex",
                    gap: 0.8,
                    px: "10px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor:
                        viewType === "grid" ? "#E4E7EC" : "#F9FAFB",
                      borderColor: "#0000001A",
                      color: "#464E60",
                    },
                  }}
                >
                  <GridIcon />
                  <Typography variant="inherit" sx={{ fontWeight: "inherit" }}>
                    Grid view
                  </Typography>
                </Button>
                <Button
                  onClick={() => {
                    setViewType("list");
                    sessionStorage.setItem("view", "list");
                  }}
                  variant="outlined"
                  sx={{
                    color: "#464E60",
                    backgroundColor:
                      viewType === "list" ? "#E4E7EC" : "transparent",
                    borderColor: "#0000001A",
                    borderRadius: "5px",
                    fontWeight: 500,
                    fontSize: "0.75rem",
                    height: "37px",
                    display: "flex",
                    gap: 0.8,
                    px: "10px",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor:
                        viewType === "list" ? "#E4E7EC" : "#F9FAFB",
                      borderColor: "#0000001A",
                      color: "#464E60",
                    },
                  }}
                >
                  <ListIcon />
                  <Typography variant="inherit" sx={{ fontWeight: "inherit" }}>
                    List view
                  </Typography>
                </Button>
              </Box>
              {/* <Typography
                variant="body2"
                mt={1}
                sx={{
                  fontWeight: { xs: 500, xl: 400 },
                  fontSize: { xs: "0.7rem", xl: "1rem" },
                }}
              >
                236,324 open jobs · 84,939 new this week
              </Typography> */}
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ borderTop: "1px solid #B9B9B9", mt: 2 }} />
        {/* ----------------------------------------------- main container */}

        {isLoading ? (
          <Grid
            container
            spacing={2}
            sx={{ mt: 2 }}
            // sx={{
            //   display: "flex",
            //   justifyContent: { xs: "start", xl: "center" },
            //   flexWrap: "wrap",
            //   gap: 2,
            //   mt: 2,
            // }}
          >
            {[1, 2, 3, 4, 5, 6, 7, 8]?.map((item) => (
              <Grid
                item
                xs={12}
                sm={viewType === "grid" ? 6 : 12}
                md={viewType === "grid" ? 4 : 12}
                key={item}
              >
                <SkeletonCard maxWidth={"100%"} />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid container spacing={1.5}>
            {isOpen ? (
              <FilterSidebar
                onApplyFilters={applyFilters}
                onClearFilters={clearFilters}
                initialFilters={appliedFilters}
                locations={locations}
                specialities={specialities}
                isFilterVisible={isFilterVisible}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
              />
            ) : (
              ""
            )}
            {isFilterVisible && (
              <Grid item xs={12} md={2.5} sx={{ mt: { xs: 5, xl: 6.5 } }}>
                <FilterSidebar
                  onApplyFilters={applyFilters}
                  onClearFilters={clearFilters}
                  initialFilters={appliedFilters}
                  locations={locations}
                  specialities={specialities}
                  isFilterVisible={isFilterVisible}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                />
              </Grid>
            )}
            <Grid
              item
              xs={12}
              md={isFilterVisible ? 9.5 : 12}
              xl={isFilterVisible ? 9.5 : 12}
              sx={{}}
            >
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                sx={{ mt: { xs: 2, xl: 4 } }}
              >
                {data?.length > 0 ? (
                  data?.map((job, index) => {
                    return (
                      <Grid
                        item
                        key={index}
                        xs={12}
                        sm={viewType === "grid" ? 6 : 12}
                        md={viewType === "grid" ? 4 : 12}
                        // xs={12}
                        // sm={viewType === "grid" ? 6 : 12}
                        // md={
                        //   isFilterVisible
                        //     ? viewType === "grid"
                        //       ? 6
                        //       : 12
                        //     : viewType === "grid"
                        //     ? 4
                        //     : 12
                        // }
                        // lg={
                        //   isFilterVisible
                        //     ? viewType === "grid"
                        //       ? 4
                        //       : 12
                        //     : viewType === "grid"
                        //     ? 3
                        //     : 12
                        // }
                        // xl={
                        //   isFilterVisible
                        //     ? viewType === "grid"
                        //       ? 3
                        //       : 12
                        //     : viewType === "grid"
                        //     ? 2.4
                        //     : 12
                        // }
                      >
                        {viewType === "grid" ? (
                          <JobCard
                            key={job?.id}
                            title={job?.title}
                            company={job?.client?.name}
                            pay={job?.regular_hourly_rate}
                            jobType={job?.jobType}
                            role={job?.role?.name}
                            speciality={job?.speciality?.name}
                            applicants={job?.applicants || applicants}
                            onApplyClick={() => handleApplyClick(job.id)}
                            onViewClick={() => handleViewClick(job)}
                            jobId={job?.id}
                            job={job}
                          />
                        ) : (
                          <ListCard
                            key={job?.id}
                            title={job?.title}
                            company={job?.client?.name}
                            desc={job?.description}
                            role={job?.role?.name}
                            created_at={job?.created_at}
                            speciality={job?.speciality?.name}
                            pay={job?.regular_hourly_rate}
                            jobType={job?.jobType}
                            applicants={job?.applicants || applicants}
                            onApplyClick={() => handleApplyClick(job.id)}
                            onViewClick={() => handleViewClick(job)}
                            jobId={job?.id}
                            job={job}
                          />
                        )}
                      </Grid>
                    );
                  })
                ) : (
                  <NodataFoundCard
                    action={() => alert("dkfkd")}
                    actionText="clear "
                  />
                )}
              </Grid>
            </Grid>
            {/* //------------------------------------------------------------------- Pagination */}
            <Box
              sx={{
                pb: 2,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                pl: 1,
              }}
            >
              {/* <Box
                sx={{
                  // width: "50px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.875rem", xl: "18px" },
                    fontWeight: 500,
                    lineHeight: { xs: "18px", xl: "21.78px" },
                  }}
                >
                  Jobs per page :
                </Typography>
                <StyledSelect
                  displayEmpty
                  size="small"
                  name="phone_type"
                  value={pagination.perPage}
                  onChange={handleChange}
                  renderValue={(selected) => {
                    if (!selected) {
                      return (
                        <Typography
                          variant="caption"
                          sx={{ color: "text.or_color" }}
                        >
                          Select
                        </Typography>
                      );
                    }
                    return selected;
                  }}
                  input={
                    <OutlinedInput
                      sx={{
                        height: "2.6rem",
                        "&.css-10l5tdt-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            padding: 0,
                          },
                        fontSize: "0.875rem",
                        border: `none`,

                        "&.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
                          {
                            border: "none",
                          },
                      }}
                    />
                  }
                  // IconComponent={ExpandMore}
                  IconComponent={(props) => (
                    <ExpandMore
                      {...props}
                      style={{
                        color: "black",
                        opacity: 0.75,
                      }}
                    />
                  )}
                  sx={{
                    border: "none",
                    fontSize: {
                      xs: "0.875rem",
                      xl: "18px",
                      lineHeight: { xs: "18px", xl: "21.94px" },
                      fontFamily: "'Montserrat', sans-serif",
                    },
                  }}
                >
                  <MenuItem value="20" sx={{ width: "120px" }}>
                    20
                  </MenuItem>
                  <MenuItem value="30">30</MenuItem>
                  <MenuItem value="50">50</MenuItem>
                  <MenuItem value="100">100</MenuItem>
                </StyledSelect>
              </Box> */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 1,
                  mt: 2,
                  width: "100%",
                }}
              >
                {/* Previous Button */}
                <Button
                  onClick={() =>
                    paginateChangeHandler(
                      null,
                      Math.max(1, pagination.currentPage - 1)
                    )
                  }
                  disabled={pagination.currentPage === 1}
                  sx={{
                    minWidth: "40px",
                    height: "40px",
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                    backgroundColor: "white",
                    color: pagination.currentPage === 1 ? "#9CA3AF" : "#374151",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor:
                        pagination.currentPage === 1 ? "white" : "#F9FAFB",
                      borderColor:
                        pagination.currentPage === 1 ? "#E5E7EB" : "#D1D5DB",
                    },
                    "&:disabled": {
                      backgroundColor: "white",
                      color: "#9CA3AF",
                      borderColor: "#E5E7EB",
                    },
                  }}
                >
                  « Previous
                </Button>

                {/* Page Numbers */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                  {(() => {
                    const currentPage = pagination.currentPage;
                    const totalPages = pagination.total;
                    const pages = [];

                    // Always show page 1
                    pages.push(
                      <Button
                        key={1}
                        onClick={() => paginateChangeHandler(null, 1)}
                        sx={{
                          minWidth: "40px",
                          height: "40px",
                          borderRadius: "8px",
                          border:
                            currentPage === 1
                              ? "1px solid #299B8D"
                              : "1px solid #E5E7EB",
                          backgroundColor:
                            currentPage === 1 ? "#F0FDFA" : "white",
                          color: currentPage === 1 ? "#299B8D" : "#374151",
                          fontSize: "0.875rem",
                          fontWeight: currentPage === 1 ? 700 : 500,
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor:
                              currentPage === 1 ? "#F0FDFA" : "#F9FAFB",
                            borderColor:
                              currentPage === 1 ? "#299B8D" : "#D1D5DB",
                          },
                        }}
                      >
                        1
                      </Button>
                    );

                    // Show ellipsis if current page is far from start
                    if (currentPage > 4) {
                      pages.push(
                        <Typography
                          key="start-ellipsis"
                          sx={{
                            minWidth: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#6B7280",
                            fontSize: "0.875rem",
                            fontWeight: 500,
                          }}
                        >
                          ...
                        </Typography>
                      );
                    }

                    // Show pages around current page
                    const startPage = Math.max(2, currentPage - 1);
                    const endPage = Math.min(totalPages - 1, currentPage + 1);

                    for (let i = startPage; i <= endPage; i++) {
                      if (i !== 1 && i !== totalPages) {
                        pages.push(
                          <Button
                            key={i}
                            onClick={() => paginateChangeHandler(null, i)}
                            sx={{
                              minWidth: "40px",
                              height: "40px",
                              borderRadius: "8px",
                              border:
                                currentPage === i
                                  ? "1px solid #299B8D"
                                  : "1px solid #E5E7EB",
                              backgroundColor:
                                currentPage === i ? "#F0FDFA" : "white",
                              color: currentPage === i ? "#299B8D" : "#374151",
                              fontSize: "0.875rem",
                              fontWeight: currentPage === i ? 700 : 500,
                              textTransform: "none",
                              "&:hover": {
                                backgroundColor:
                                  currentPage === i ? "#F0FDFA" : "#F9FAFB",
                                borderColor:
                                  currentPage === i ? "#299B8D" : "#D1D5DB",
                              },
                            }}
                          >
                            {i}
                          </Button>
                        );
                      }
                    }

                    // Show ellipsis if current page is far from end
                    if (currentPage < totalPages - 3) {
                      pages.push(
                        <Typography
                          key="end-ellipsis"
                          sx={{
                            minWidth: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#6B7280",
                            fontSize: "0.875rem",
                            fontWeight: 500,
                          }}
                        >
                          ...
                        </Typography>
                      );
                    }

                    // Always show last page (if more than 1 page)
                    if (totalPages > 1) {
                      pages.push(
                        <Button
                          key={totalPages}
                          onClick={() =>
                            paginateChangeHandler(null, totalPages)
                          }
                          sx={{
                            minWidth: "40px",
                            height: "40px",
                            borderRadius: "8px",
                            border:
                              currentPage === totalPages
                                ? "1px solid #299B8D"
                                : "1px solid #E5E7EB",
                            backgroundColor:
                              currentPage === totalPages ? "#F0FDFA" : "white",
                            color:
                              currentPage === totalPages
                                ? "#299B8D"
                                : "#374151",
                            fontSize: "0.875rem",
                            fontWeight: currentPage === totalPages ? 700 : 500,
                            textTransform: "none",
                            "&:hover": {
                              backgroundColor:
                                currentPage === totalPages
                                  ? "#F0FDFA"
                                  : "#F9FAFB",
                              borderColor:
                                currentPage === totalPages
                                  ? "#299B8D"
                                  : "#D1D5DB",
                            },
                          }}
                        >
                          {totalPages}
                        </Button>
                      );
                    }

                    return pages;
                  })()}
                </Box>

                {/* Next Button */}
                <Button
                  onClick={() =>
                    paginateChangeHandler(
                      null,
                      Math.min(pagination.total, pagination.currentPage + 1)
                    )
                  }
                  disabled={pagination.currentPage === pagination.total}
                  sx={{
                    minWidth: "40px",
                    height: "40px",
                    borderRadius: "8px",
                    border: "1px solid #E5E7EB",
                    backgroundColor: "white",
                    color:
                      pagination.currentPage === pagination.total
                        ? "#9CA3AF"
                        : "#374151",
                    fontSize: "0.875rem",
                    fontWeight: 500,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor:
                        pagination.currentPage === pagination.total
                          ? "white"
                          : "#F9FAFB",
                      borderColor:
                        pagination.currentPage === pagination.total
                          ? "#E5E7EB"
                          : "#D1D5DB",
                    },
                    "&:disabled": {
                      backgroundColor: "white",
                      color: "#9CA3AF",
                      borderColor: "#E5E7EB",
                    },
                  }}
                >
                  Next »
                </Button>
              </Box>
            </Box>
            {/* //------------------------------------------------------------------- Pagination end */}
          </Grid>
        )}
        {/* ----------------------------------------------------------------------------- why choose us */}
        <ChooseUs />
        {/* ----------------------------------------------------------------------------- why choose us end */}
      </Box>
    </Box>
  );
};

export default BrowseJobs;
